import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首頁", href: "/" },
  { label: "品牌故事", href: "/about" },
  { label: "商品分類", href: "/shop" },
  { label: "穿搭提案", href: "/lookbook" },
  { label: "最新消息", href: "/news" },
  { label: "穿搭專欄", href: "/blog" },
  { label: "顧客好評", href: "/reviews" },
  { label: "FAQ", href: "/faq" },
  { label: "門市資訊", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? "bg-[#faf8f5] shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="w-full px-6 md:px-12 flex items-center justify-between h-[72px]">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/63b8b7b1f5a3fb4c3a27d835417dcfba.png"
              alt="品牌Logo"
              className="h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-[1.0625rem] font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? location.pathname === link.href
                      ? "text-[#8B5E52]"
                      : "text-[#3d2b1f] hover:text-[#8B5E52]"
                    : location.pathname === link.href
                    ? "text-[#f5e6dc]"
                    : "text-white hover:text-[#f5c9a8]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/appointment"
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-[0.875rem] font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "border border-[#8B5E52] text-[#8B5E52] hover:bg-[#8B5E52] hover:text-white"
                  : "border border-white/60 text-white hover:bg-white/20"
              }`}
            >
              <i className="ri-calendar-check-line text-sm"></i>
              預約試穿
            </Link>
            <a
              href="https://line.me"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-2 px-5 py-2 rounded-full text-[0.9375rem] font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "bg-[#3d2b1f] text-[#faf8f5] hover:bg-[#8B5E52]"
                  : "bg-white/20 text-white border border-white/40 hover:bg-white/30"
              }`}
            >
              <i className="ri-line-fill text-base"></i>
              加入 LINE
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? "text-[#3d2b1f]" : "text-white"
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="開啟選單"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`}></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="absolute inset-0 bg-[#3d2b1f]/90 backdrop-blur-sm" onClick={() => setMenuOpen(false)} />
        <nav className="absolute top-[72px] left-0 right-0 bg-[#faf8f5] px-6 py-6 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-[1.125rem] font-medium py-3 border-b border-[#ede8e0] transition-colors cursor-pointer ${
                location.pathname === link.href
                  ? "text-[#8B5E52]"
                  : "text-[#3d2b1f] hover:text-[#8B5E52]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/appointment"
            className="mt-4 flex items-center justify-center gap-2 border-2 border-[#3d2b1f] text-[#3d2b1f] py-3 rounded-full text-[1rem] font-semibold cursor-pointer whitespace-nowrap hover:bg-[#3d2b1f] hover:text-[#faf8f5] transition-colors"
          >
            <i className="ri-calendar-check-line"></i> 預約試穿
          </Link>
          <a
            href="https://line.me"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 flex items-center justify-center gap-2 bg-[#3d2b1f] text-[#faf8f5] py-3 rounded-full text-[1rem] font-semibold cursor-pointer whitespace-nowrap"
          >
            <i className="ri-line-fill"></i> 加入 LINE 諮詢
          </a>
        </nav>
      </div>
    </>
  );
}
